const keyToken = {}; // Arbitrary object reference as unique context identifier.
const keyUser = {};

const ROLE_VIEWER = 'VIEWER';

export {
	keyToken,
	keyUser,
	ROLE_VIEWER
};
